
//
// Ajax Pending Notice
//
// Turn a 'results pending, please wait' notice into either it's positive or negative form
// when the results finally arrive. Will do a pluraliseBody pass when ready based on an integer
// passed to the display functions.
//

module.exports = function AjaxPendingNotice ($host, config) {

  // Dom
  var $pending  = $('[data-pending-notice]',  $host);
  var $positive = $('[data-positive-notice]', $host);
  var $negative = $('[data-negative-notice]', $host);

  // Interface
  return {
    showPositive: function (pluralCount) {
      $pending.hide();
      var $noticeBody = $positive.find('.notice-body');
      $noticeBody.html( pluraliseBody($noticeBody.html().trim(), pluralCount) );
      $positive.show();
    },

    showNegative: function (pluralCount) {
      $pending.hide();
      var $noticeBody = $negative.find('.notice-body');
      $noticeBody.html( pluraliseBody($noticeBody.html().trim(), pluralCount) );
      $negative.show();
    },

    showErrorMessage: function (msg) {
      $pending.hide();
      var $noticeBody = $negative.find('.notice-body');
      $noticeBody.html("<h4>Error</h4><p>" + msg + "</p>");
      $negative.show();
    }
  }

};
